import { PageLayout } from "@gearbox-protocol/ui-kit";
import { ClipboardX } from "lucide-react";
import { ProposalCard } from "@/components/proposals/proposal-card";
import { SkeletonProposalCard } from "@/components/proposals/skeleton-proposal-card";
import { useCurrentProposals } from "@/hooks/use-current-proposals";

export function ProposalsPage() {
  const { currentProposals, isLoading, error } = useCurrentProposals();

  return (
    <PageLayout title="Governance Multisig">
      {currentProposals === undefined ? (
        isLoading ? (
          <div className="space-y-2">
            {Array.from({ length: 5 }).map((_, index) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: <Allow index as key for indistinguishable rows>
              <SkeletonProposalCard key={index} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <ClipboardX className="w-16 h-16 text-muted-foreground mb-4" />
            <p className="text-muted-foreground text-lg">{`Error loading proposals: ${
              error?.message ?? "Unknown error"
            }`}</p>
          </div>
        )
      ) : currentProposals.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12">
          <ClipboardX className="w-16 h-16 text-muted-foreground mb-4" />
          <p className="text-muted-foreground text-lg">Nothing to sign</p>
        </div>
      ) : (
        <div className="space-y-2">
          {currentProposals.map(tx => (
            <ProposalCard key={tx.hash} proposal={tx} isQueue />
          ))}
        </div>
      )}
    </PageLayout>
  );
}
